import Vue from 'vue';
import Helper from '@/Utilities/Helper';
Vue.prototype.$helper = Helper;
Vue.prototype.$_ = window._;
